import React, { useEffect, useState } from 'react';
import { Building2, Users, Search, Building } from 'lucide-react';
import { Container, Row, Col } from 'reactstrap';
import axios from 'axios';
import { getCookie } from "../../helpers/cookie"

const Organization = () => {
    const token = getCookie('access_token');
    const [deptSearch, setDeptSearch] = useState('');
    const [desigSearch, setDesigSearch] = useState('');
    const [companySearch, setCompanySearch] = useState('');
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [companies, setCompanies] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [loader, setLoader] = useState(false);
    const [departmentloader, setDepartmentLoader] = useState(false);
    const [designationloader, setDesignationLoader] = useState(false);
     const [Loader,setloader] = useState(sessionStorage.getItem("ismenuLoaded"));
    useEffect(() => {
      setInterval(() => {
        setloader(sessionStorage.getItem("ismenuLoaded"));
      }, 100)
      clearInterval();
    }, []);
    const getCompanies = async () => {
        setLoader(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/companies/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                setCompanies(response.data.results);
                const parentCompany = response.data.results.find(
                    (c) => c.is_parent_company === true
                );
                if (parentCompany) {
                    getDepartments(parentCompany.id);
                    getDesignations(parentCompany.id);
                    setSelectedCompany(parentCompany)
                }
                setLoader(false);
            }
        } catch (error) {
            console.error("Error fetching companies:", error);
            setLoader(false);
        }
    }

    const getDesignations = async (selectedCompanyid) => {
        try {
            setDesignationLoader(true);
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/designations/?company_id=${selectedCompanyid}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                console.log("Departments fetched:", response.data);
                setDesignations(response.data.results);
                setDesignationLoader(false);
            }
        } catch (error) {
            console.error("Error fetching designations:", error);
            setDesignationLoader(false);
        }

    }
    const getDepartments = async (selectedCompanyid) => {
        try {
            setDepartmentLoader(true);
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/departments/?company_id=${selectedCompanyid}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                setDepartments(response.data.results);
                setDepartmentLoader(false);
            }
        } catch (error) {
            console.error("Error fetching departments:", error);
            setDepartmentLoader(false);
        }

    }
    useEffect(() => {
        getCompanies();
    }, []);
    const normalize = (str) =>
  str.toLowerCase().replace(/[\s-_]/g, '');
const filteredDepts = departments.filter(d =>
  normalize(d.name).includes(normalize(deptSearch))
);

const filteredDesigs = designations.filter(des =>
  normalize(des.name).includes(normalize(desigSearch))
);

const filteredCompanies = companies.filter(c =>
  normalize(c.name).includes(normalize(companySearch))
);

    // const filteredDepts = departments.filter(d =>
    //     d.name.toLowerCase().includes(deptSearch.toLowerCase())
    // );

    // const filteredDesigs = designations.filter(des =>
    //     des.name.toLowerCase().includes(desigSearch.toLowerCase())
    // );

    // const filteredCompanies = companies.filter(c =>
    //     c.name.toLowerCase().includes(companySearch.toLowerCase())
    // );

    return (
        <React.Fragment>
            <div className="page-content allact-tabs">
               {Loader === "false" && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backdropFilter: "blur(6px)",  // 💥 BLUR BACKGROUND
      backgroundColor: "rgba(255, 255, 255, 0.4)", // soft overlay
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999
    }}
  >
    <div
      style={{
        width: "45px",
        height: "45px",
        border: "4px solid #ddd",
        borderTopColor: "#126fa9",
        borderRadius: "50%",
        animation: "spin 0.8s linear infinite"
      }}
    ></div>
  </div>
)}

                <Container fluid>
                    <div className="page-title-box actjobbread">
                        <Row className="g-4">
                            <Col md={4}>

                                <div className="mb-4">
                                    <div className="flex  mb-4 gap-3 items-center px-3">
                                        <Building className=" h-7 text-green-600" />
                                        <h2 className="text-xl font-semibold text-gray-800">
                                            Companies
                                            <span className="text-sm text-gray-500 ml-2">
                                                ({filteredCompanies.length})
                                            </span>
                                        </h2>
                                    </div>

                                    {/* Search */}
                                    <div className="relative mb-4 px-3">
                                        {/* <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" /> */}
                                        <input
                                            type="text"
                                            placeholder="Search companies..."
                                            value={companySearch}
                                            onChange={(e) => setCompanySearch(e.target.value)}
                                            className="w-full px-2 pr-4 py-2 text-sm border rounded"
                                        />
                                    </div>
                                </div>

                                {/* Cards */}
                                <div className='px-3 CompanyContainer py-3' style={{ height: "67vh", overflowY: "scroll" }}>
                                      {loader && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)"
                                            }}
                                        >
                                            <div className="loader-spinner"></div>
                                        </div>
                                    )}
                                    {!loader && filteredCompanies.map((company, i) => (
                                        <div
                                            key={i}
                                            onClick={() => {setSelectedCompany(company); getDepartments(company.id);getDesignations(company.id);}}
                                            className="bg-white rounded shadow px-4 py-2 mb-2 cursor-pointer"
                                            style={{
                                                border: selectedCompany?.id === company?.id
                                                    ? "2px solid #126fa9"
                                                    : "1px solid transparent"
                                            }}
                                        >

                                            <div className="flex align-items-center justify-content-between">
                                                <h3 className="font-semibold text-gray-800 text-sm mb-0">
                                                    {company.name}
                                                </h3>
                                                <div className="text-right">
                                                    <p className="text-lg font-bold mb-1">{company.employee_count}</p>
                                                    <p className="text-xs text-gray-500 mb-1">Employee Count</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </Col>
                            {/* ========== DEPARTMENTS ========== */}
                            <Col md={4}>
                                <div className="mb-4">
                                    <div className="flex items-center gap-3 mb-4 px-3">
                                        <Building2 className=" h-7 text-blue-600" />
                                        <h2 className="text-xl font-semibold text-gray-800">
                                            Departments
                                            <span className="text-sm text-gray-500 ml-2">
                                                ({filteredDepts.length})
                                            </span>
                                        </h2>
                                    </div>

                                    {/* Search */}
                                    <div className="relative mb-4 px-3">
                                        {/* <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" /> */}
                                        <input
                                            type="text"
                                            placeholder="Search departments..."
                                            value={deptSearch}
                                            onChange={(e) => setDeptSearch(e.target.value)}
                                            className="w-full px-2 pr-4 py-2 text-sm border rounded"
                                        />
                                    </div>
                                </div>

                                {/* Cards */}
                                <div className='px-3 CompanyContainer py-3' style={{ height: "67vh", overflowY: "scroll" }}>
                                    {departmentloader && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)"
                                            }}
                                        >
                                            <div className="loader-spinner"></div>
                                        </div>
                                    )}
                                    {filteredDepts.length === 0 ? (
                                        <div className="text-center text-gray-500 mt-5">
                                            <p className="text-sm font-medium">No departments found for the selected company</p>
                                        </div>
                                    ) : (
                                          !departmentloader &&filteredDepts.map((dept, i) => (
                                            <div key={i} className="bg-white rounded shadow px-4 py-2 mb-2">
                                                <div className="flex align-items-center justify-content-between">
                                                    <div className="flex align-items-center gap-4">
                                                        <div>
                                                            <h3 className="font-semibold text-gray-800 text-sm mb-0">
                                                                {dept.name}
                                                            </h3>
                                                        </div>
                                                    </div>

                                                    <div className="text-right">
                                                        <p className="text-lg font-bold mb-1">{dept.employee_count}</p>
                                                        <p className="text-xs text-gray-500 mb-1">Employee Count</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </Col>


                            {/* ========== DESIGNATIONS ========== */}
                            <Col md={4}>
                                <div className="mb-4">
                                    <div className="flex items-center gap-3 mb-4 px-3">
                                        <Users className=" h-7 text-purple-600" />
                                        <h2 className="text-xl font-semibold text-gray-800">
                                            Designations
                                            <span className="text-sm text-gray-500 ml-2">
                                                ({filteredDesigs.length})
                                            </span>
                                        </h2>
                                    </div>

                                    {/* Search */}
                                    <div className="relative mb-4 px-3">
                                        {/* <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" /> */}
                                        <input
                                            type="text"
                                            placeholder="Search designations..."
                                            value={desigSearch}
                                            onChange={(e) => setDesigSearch(e.target.value)}
                                            className="w-full px-2 pr-4 py-2 text-sm border rounded"
                                        />
                                    </div>
                                </div>

                                {/* Cards */}
                                <div className='px-3 CompanyContainer py-3' style={{ height: "67vh", overflowY: "scroll" }}>
                                      {designationloader && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)"
                                            }}
                                        >
                                            <div className="loader-spinner"></div>
                                        </div>
                                    )}
                                     {filteredDesigs.length === 0 ? (
                                        <div className="text-center text-gray-500 mt-5">
                                            <p className="text-sm font-medium">No designations found for the selected company</p>
                                        </div>
                                    ) : (
                                    !designationloader && filteredDesigs.map((d, i) => (
                                        <div key={i} className="bg-white rounded shadow px-4 py-2 mb-2">
                                            <div className="flex align-items-center justify-content-between">
                                                <div>
                                                    <h3 className="font-semibold text-gray-800 text-sm mb-0">
                                                        {d.name}
                                                    </h3>
                                                    {/* <p className="text-xs text-purple-600 mt-1">{d.level}</p> */}
                                                </div>
                                                <div className="text-right">
                                                    <p className="text-lg font-bold mb-1">{d.employee_count}</p>
                                                    <p className="text-xs text-gray-500 mb-1">Employee Count</p>
                                                </div>
                                            </div>
                                        </div>
                                    )))}
                                </div>
                            </Col>




                        </Row>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Organization;
